// extracted by mini-css-extract-plugin
export default {"Backdrop":"ModalPage_Backdrop__LB46o","Content":"ModalPage_Content__ASLZL","Btn_close":"ModalPage_Btn_close__wVaWX"};